import React from 'react';
import { HeaderSubnavLink } from 'components/Header/HeaderSubnavLink';
import { Flex, Box } from 'rebass';
import { SmallLink } from 'components/Header/SmallLink';
import CanShow from 'components/AppPermissions/CanShow';
import H1 from 'components/H1';
import { FiSettings, FiUsers, FiZap, FiMail, FiBarChart2 } from 'react-icons/fi';

function SettingsPageSubNav(props) {
    return (
        <Flex sx={{ flexDirection: 'row' }}>
            <HeaderSubnavLink exact to={`/settings`} className='basic-subnav'>
                <FiSettings/> General
            </HeaderSubnavLink>
            <HeaderSubnavLink to={`/settings/users`} className='basic-subnav'>
                <FiUsers/> Users
            </HeaderSubnavLink>
            {/*<CanShow role="user">*/}
            <HeaderSubnavLink to={`/settings/integrations`} className='basic-subnav'>
                <FiZap/> Integrations
            </HeaderSubnavLink>
            {/*</CanShow>*/}
            <HeaderSubnavLink to={`/settings/email-templates`} className='basic-subnav'>
                <FiMail/> Email Templates
            </HeaderSubnavLink>

            <HeaderSubnavLink to={`/settings/usage`} className='basic-subnav'>
                <FiBarChart2 style={{fontSize: '15px' }} /> Usage
            </HeaderSubnavLink>
        </Flex>
    );
}

export default SettingsPageSubNav;
